/**
 * Calculate the distance between two points on the surface of a sphere.
 *
 * @param x1 GPS X (Latitude) coordinate of the first point in degrees.
 * @param y1 GPS Y (Longitude) coordinate of the first point in degrees.
 * @param x2 GPS X (Latitude) coordinate of the second point in degrees.
 * @param y2 GPS Y (Longitude) coordinate of the second point in degrees.
 * @param radius  The radius of the sphere. Default is Earth's radius in meters.
 * @returns The distance between the two points
 */
export const sphereDistance = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  rounding = 1,
  radius = 6_371_000,
) => {
  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;
  const hav = (theta: number) => Math.pow(Math.sin(theta / 2), 2);

  // prettier-ignore
  const distance = (
    2 *
    radius *
    Math.asin(
      Math.sqrt(
        hav(toRadians(y2 - y1)) + Math.cos(toRadians(y1)) * Math.cos(toRadians(y2)) * hav(toRadians(x2 - x1)),
      ),
    )
  );
  const pow = Math.pow(10, rounding);
  return Math.round(distance * pow) / pow;
};
